"use client";

import React from "react";
import { cn } from "@/lib/utils";
import "./shiny-button.css";

interface ShinyButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const ShinyButton = React.forwardRef<HTMLButtonElement, ShinyButtonProps>(
  ({ children, className, type = "button", ...props }, ref) => {
    return (
      <button ref={ref} type={type} className={cn("shiny-cta", className)} {...props}>
        <span>{children}</span>
      </button>
    );
  },
);

ShinyButton.displayName = "ShinyButton";
